export const gallerySection =
{
  "title": "Explore Our Work",
  "columns": 3,
  "rowHeight": 1200,
  "pageSize": 9,
  "images": [
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/1.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/2.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/3.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/4.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/5.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/6.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/7.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/8.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/9.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/10.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/11.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/12.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/13.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/14.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/15.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/16.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/17.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/18.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/19.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/20.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/21.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/22.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/23.jpg", "rowSpan": 2, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/24.jpg", "rowSpan": 1, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/25.jpg", "rowSpan": 2, "colSpan": 1 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/26.jpg", "rowSpan": 1, "colSpan": 2 },
    { "src": "/assets/imgs/services/0002CaulkingSealantRenewals/27.jpg", "rowSpan": 2, "colSpan": 2 }
  ]
}